import DefaultMessages, { MessageDefault } from '@powerednow/shared/constants/customerEmailTemplateValues';

const MessageIdToMessage: Record<number, MessageDefault> = Object.entries(DefaultMessages).reduce((acc, [key, value]) => ({
    ...acc,
    [value.ID]: value,
}), {});

export default MessageIdToMessage;
